var map = {
	"./BoD_Badge_Logo.png": 272,
	"./DDC_BestofDayton_19_937x360.jpg": 273,
	"./DDC_BestofDayton_19_IGPost_1080x1080.jpg": 274,
	"./DDC_BestofDayton_201920_ProfPic_400x400.jpg": 275,
	"./bod_slate_wide.jpg": 276,
	"./dayton-dotcom-logo.png": 117,
	"./logo.png": 277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 271
// module chunks = 1